/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type InsertLastSeenActionMutationVariables = Exact<{
  object: Types.ZalamoObject;
  objectId: string;
  organizationId: string;
}>;

export type InsertLastSeenActionMutation = {
  insertLastSeenForType: boolean | null;
};

export type GetLastSeenQueryVariables = Exact<{
  object: Types.ZalamoObject;
  organizationId: string;
}>;

export type GetLastSeenQuery = {
  geLastSeenForType: Array<string | null> | null;
};

export const InsertLastSeenActionDocument = gql`
  mutation insertLastSeenAction(
    $object: ZalamoObject!
    $objectId: ID!
    $organizationId: ID!
  ) {
    insertLastSeenForType(
      object: $object
      objectId: $objectId
      organizationId: $organizationId
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class InsertLastSeenActionGQL extends Apollo.Mutation<
  InsertLastSeenActionMutation,
  InsertLastSeenActionMutationVariables
> {
  document = InsertLastSeenActionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetLastSeenDocument = gql`
  query getLastSeen($object: ZalamoObject!, $organizationId: ID!) {
    geLastSeenForType(object: $object, organizationId: $organizationId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetLastSeenGQL extends Apollo.Query<
  GetLastSeenQuery,
  GetLastSeenQueryVariables
> {
  document = GetLastSeenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
